"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMicrounits = formatMicrounits;
var _intlFormatter = require("@godaddy/intl-formatter");
const currencyFormatter = new _intlFormatter.Currency();
function formatMicrounits(priceValue, market, currency) {
  return currencyFormatter.formatMicrounits(priceValue, market, currency);
}